import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import bridge from '@vkontakte/vk-bridge';
import moment from 'moment';
import {
    View,
    Panel,
    Avatar,
    PanelHeader,
    FixedLayout,
    Div,
    Button,
    Title,
    Text
} from '@vkontakte/vkui';
import Icon16CheckCircle from '@vkontakte/icons/dist/16/check_circle';
import Icon16Clear from '@vkontakte/icons/dist/16/clear';
import '@vkontakte/vkui/dist/vkui.css';
import { ReactComponent as ShareSaveIcon } from '../../assets/share-save.svg';
import { ReactComponent as ShareTgIcon } from '../../assets/share-tg.svg';
import { ReactComponent as ShareVkIcon } from '../../assets/share-vk.svg';

import { API_SERVER } from '../../constans/api';
import {
    switchInitAction
} from '../filter/actions';
import { getScheduleAction, resetDataScheduleAction } from '../schedule/actions';
import { initialState as initFilter } from '../filter/reducer';
import { setScheduleInterval } from '../../helpers';
import {
    setVKPhoneAction,
    setVKUserIDAction,
    setActiveModalVKAction,
    setActivePanelVKAction,
    getVKUserAction,
    addVKUserAction
} from './actions';
import ModalFastWrite from './modalFastWrite';
import './style.scss';

const VKWrapper = (Component) => {
    class VKApp extends React.PureComponent {
        constructor() {
            super();

            const { search } = window.location;
            if (search !== '') {
                const params = new URLSearchParams(search);
                const platform = params.get('vk_platform');

                switch (platform) {
                    case 'desktop_web':
                        document.getElementsByTagName('html')[0].style.cssText = 'background: #fff;';
                        document.getElementsByTagName('body')[0].style.cssText = 'background: #fff;';
                        break;
                    default:
                        break;
                }
            }
        }

        componentDidMount() {
            const { search, href } = window.location;
            const { dispatch } = this.props;

            if (search !== '') {
                const params = new URLSearchParams(search);
                const vkUserID = params.get('vk_user_id');

                dispatch(setVKUserIDAction(vkUserID));
                dispatch(getVKUserAction(vkUserID, href));

                bridge.send('VKWebAppInit');
                bridge.send('VKWebAppGetUserInfo');

                bridge.subscribe((e) => {
                    const { type, data } = e.detail;
                    if (type === 'VKWebAppGetPhoneNumberResult') {
                        dispatch(setVKPhoneAction(data.phone_number, vkUserID, href));
                    }
                    if (type === 'VKWebAppGetUserInfoResult') {
                        dispatch(addVKUserAction(data, href));
                    }
                });
            }
        }

        componentDidUpdate(prevProps) {
            const { vk: prevVK } = prevProps;
            const { vk } = this.props;

            if (prevVK.hasRequestedPhone !== vk.hasRequestedPhone && vk.userInfo.phone === null) {
                bridge.send('VKWebAppGetPhoneNumber', {});
            }
        }

        toMain = () => {
            const {
                dispatch,
                filter,
                vk
            } = this.props;

            if (vk.activePanel !== 'schedulePanel') {
                dispatch(resetDataScheduleAction());
                dispatch(switchInitAction());
                dispatch(getScheduleAction({ ...filter, ...initFilter }));
                setScheduleInterval({ ...filter, ...initFilter }, dispatch);
                dispatch(setActivePanelVKAction('schedulePanel'));
            } else if (filter.typeView.value !== 'month') {
                dispatch(resetDataScheduleAction());
                dispatch(switchInitAction());
                dispatch(getScheduleAction({ ...filter, ...initFilter }));
                setScheduleInterval({ ...filter, ...initFilter }, dispatch);
            }
        }

        toFastWrite = () => {
            const { dispatch } = this.props;

            dispatch(setActiveModalVKAction('FastWrite'));
        }

        render() {
            const { vk, schedule } = this.props;
            const { search } = window.location;
            const { settings, screens } = schedule;
            const logo = settings && settings.logo ? `${API_SERVER}${settings.logo}` : '//schedule-dist.redken.online/v1/admin/assets/logo.png';
            const organization = settings && settings.organization ? settings.organization : 'ВедёмПриём';

            const date = screens.success.data ? moment(screens.success.data.date_write).format('dddd, DD.MM.YYYY') : '';
            const time = screens.success.data ? `${moment(screens.success.data.time_start).format('HH:mm')}-${moment(screens.success.data.time_end).format('HH:mm')}` : '';
            const title = screens.success.data ? screens.success.data.success_message.title : ' ';
            const text = screens.success.data ? screens.success.data.success_message.text.replace('%date_write%', `${date} ${time}`) : ' ';
            const pdf = screens.success.data ? screens.success.data.pdf : '';

            if (search !== '') {
                return (
                    <div className="vk-app">
                        <View activePanel={vk.activePanel} modal={<ModalFastWrite />}>
                            <Panel id="schedulePanel">
                                <PanelHeader
                                    left={<Avatar size={36} src={logo} onClick={() => this.toMain()} />}
                                >
                                    {organization}
                                </PanelHeader>
                                <Div style={{ height: 600 }}>
                                    <Component {...this.props} />
                                </Div>
                                {vk.activePanel === 'schedulePanel' ? (
                                    <FixedLayout vertical="bottom">
                                        <Div>
                                            <Button size="xl" mode="primary" onClick={() => this.toFastWrite()}>Быстрая запись</Button>
                                        </Div>
                                    </FixedLayout>
                                ) : null}
                            </Panel>
                            <Panel id="successPanel" centered style={{ height: '100vh' }}>
                                <PanelHeader
                                    left={<Avatar size={36} src={logo} onClick={() => this.toMain()} />}
                                >
                                    {organization}
                                </PanelHeader>
                                <Icon16CheckCircle width={128} height={128} style={{ color: 'var(--dynamic_green)' }} />
                                <Title level="1" weight="semibold" style={{ marginTop: 16 }} dangerouslySetInnerHTML={{ __html: title }} />
                                <Div>
                                    <Text
                                        weight="regular"
                                        style={{ color: 'var(--text_secondary)', textAlign: 'center' }}
                                        dangerouslySetInnerHTML={{ __html: text }}
                                    />
                                </Div>
                                <div className="screen__share share">
                                    <span>Сохранить талон:</span>
                                    <div className="share__items">
                                        <a href={pdf} download className="share__item">
                                            <ShareSaveIcon />
                                            <span>Сохранить на устройство</span>
                                        </a>
                                        <a href={`https://vk.com/share.php?url=${pdf}`} target="_blank" rel="noreferrer" className="share__item">
                                            <ShareVkIcon />
                                            <span>Отправить в VK</span>
                                        </a>
                                        <a href={`https://telegram.me/share/url?url=${pdf}&text=Талон на приём`} target="_blank" rel="noreferrer" className="share__item">
                                            <ShareTgIcon />
                                            <span>Отправить в Telegram</span>
                                        </a>
                                    </div>
                                </div>
                                {settings && settings.notify_write_bot && (
                                    <div className="screen__notify notify">
                                        <span>Уведомления</span>
                                        <p>Подпишитесь на бота, чтобы получать уведомления о записи в VK. Просто напишите <a href="https://vk.com/im?sel=-223583302">нашему боту</a>.</p>
                                    </div>
                                )}
                            </Panel>
                            <Panel id="errorPanel" centered>
                                <PanelHeader
                                    left={<Avatar size={36} src={logo} onClick={() => this.toMain()} />}
                                >
                                    {organization}
                                </PanelHeader>
                                <Icon16Clear width={128} height={128} style={{ color: 'var(--dynamic_red)' }} />
                                <Title level="1" weight="semibold" style={{ marginTop: 16 }}>Произошла ошибка. ;(</Title>
                            </Panel>
                        </View>
                    </div>
                );
            }

            return <Component {...this.props} />;
        }
    }


    VKApp.propTypes = {
        dispatch: PropTypes.func.isRequired,
        filter: PropTypes.object.isRequired,
        vk: PropTypes.object.isRequired,
        schedule: PropTypes.object.isRequired
    };

    const mapStateToProps = state => ({
        vk: state.vk,
        schedule: state.schedule
    });

    return connect(mapStateToProps)(VKApp);
};

export default VKWrapper;
